import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const RoleNavigation = ({ role = 'influencer', userName = 'User' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigationItems = {
    influencer: [
      { label: 'Dashboard', path: '/user-dashboard', icon: 'LayoutDashboard' },
      { label: 'Analytics', path: '/influencer-analytics-screen', icon: 'BarChart3' },
      { label: 'Submit Purchase', path: '/transaction-submission-screen', icon: 'Upload' },
      { label: 'SocialCents Card', path: '/social-cents-card-screen', icon: 'CreditCard' },
      { label: 'Profile', path: '/user-onboarding-screen', icon: 'User' }
    ],
    brand: [
      { label: 'Dashboard', path: '/brand-dashboard', icon: 'LayoutDashboard' },
      { label: 'Profile', path: '/user-onboarding-screen', icon: 'Building2' }
    ],
    admin: [
      { label: 'Admin Panel', path: '/admin-panel', icon: 'Shield' },
      { label: 'Dashboard', path: '/user-dashboard', icon: 'LayoutDashboard' }
    ]
  };

  const currentItems = navigationItems?.[role] || navigationItems?.influencer;

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    navigate('/login-screen');
    setMobileMenuOpen(false);
  };

  const isActive = (path) => location?.pathname === path;

  return (
    <>
      <nav className="role-navigation">
        <div className="role-navigation-logo">
          <img
            src="/assets/images/image-1772733559968.png"
            alt="SocialCents logo"
            className="h-8 w-auto object-contain"
          />
        </div>

        <div className="role-navigation-menu">
          {currentItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`role-navigation-item ${isActive(item?.path) ? 'active' : ''}`}
            >
              <Icon name={item?.icon} size={18} />
              {item?.label}
            </button>
          ))}
        </div>

        <div className="role-navigation-actions">
          <Button
            variant="ghost"
            size="sm"
            iconName="LogOut"
            onClick={handleLogout}
            className="hidden lg:flex"
          >
            Logout
          </Button>
        </div>
      </nav>
      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className="role-navigation-mobile-toggle"
        aria-label="Toggle mobile menu"
      >
        <Icon name={mobileMenuOpen ? 'X' : 'Menu'} size={24} />
      </button>
      <div className={`role-navigation-mobile-menu ${!mobileMenuOpen ? 'closed' : ''}`}>
        <div className="role-navigation-mobile-header">
          <div className="role-navigation-logo">
            <img
              src="/assets/images/image-1772733559968.png"
              alt="SocialCents logo"
              className="h-8 w-auto object-contain"
            />
          </div>
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="w-11 h-11 flex items-center justify-center text-foreground hover:bg-muted rounded-lg transition-colors"
            aria-label="Close menu"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="role-navigation-mobile-items">
          {currentItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`role-navigation-mobile-item ${isActive(item?.path) ? 'active' : ''}`}
            >
              <Icon name={item?.icon} size={20} />
              {item?.label}
            </button>
          ))}

          <div className="mt-8 pt-8 border-t border-border">
            <button
              onClick={handleLogout}
              className="role-navigation-mobile-item"
            >
              <Icon name="LogOut" size={20} />
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleNavigation;